// set to true when we are focusing elements with try focus so trap listener can ignore it
let _ignoreFocusEvent = false;

function tryFocus (el) {
    _ignoreFocusEvent = true;
    if (typeof el === 'object' && 'focus' in el && el.tabIndex != -1) el.focus();
    _ignoreFocusEvent = false;
    return document.activeElement === el;
};

export function focusFirstElementInside (el) {
    if (tryFocus(el)) return true;

    const children = Array.from(el.childNodes);
    for (const child of children) if (focusFirstElementInside(child)) return true;

    return false;
}

export function focusLastElementInside (el) {
    if (tryFocus(el)) return true;

    const children = Array.from(el.childNodes);
    const len = children.length;
    for (let i = len - 1; i >= 0; i--) {
        if (focusLastElementInside(children[i])) return true;
    }

    return false;
}

const META_DATA = new WeakMap();

function createTrapFocusListener (dialog) {
    return function () {
        if (_ignoreFocusEvent || !META_DATA.has(dialog)) return;

        const data = META_DATA.get(dialog);
        if (dialog.contains(document.activeElement)) {
            data.lastFocus = document.activeElement;
        } else {
            focusFirstElementInside(dialog);
            if (data.lastFocus === document.activeElement) focusLastElementInside(dialog);
            data.lastFocus = document.activeElement;
        }
    };
}

function createTabindexedNode (dialog, after = false) {
    const node = document.createElement('div');
    const parent = dialog.parentNode;
    if (!after) parent.insertBefore(node, dialog);
    else parent.insertBefore(node, dialog.nextSibling);

    node.tabIndex = 0;
    return node;
}

function removeNodes (nodes) {
    Array.prototype.forEach.call(nodes, function (node) {
        if (node.parentNode) node.parentNode.removeChild(node);
    });
}

export function startDialogBehaviour (dialog) {
    if (META_DATA.has(dialog)) return;
    
    const focusBefore = document.activeElement;
    const preNode = createTabindexedNode(dialog, false);
    const postNode = createTabindexedNode(dialog, true);
    const focusListener = createTrapFocusListener(dialog);

    dialog.setAttribute('aria-hidden', 'false');

    focusFirstElementInside(dialog);
    document.addEventListener('focus', focusListener, true);
    META_DATA.set(dialog, { focusBefore, focusListener, lastFocus: document.activeElement, postNode, preNode });
}

export function stopDialogBehaviour (dialog) {
    if (!META_DATA.has(dialog)) return;
    const { focusBefore, focusListener, preNode, postNode } = META_DATA.get(dialog);

    removeNodes([ preNode, postNode ]);

    dialog.setAttribute('aria-hidden', 'true');

    document.removeEventListener('focus', focusListener);
    META_DATA.delete(dialog);
    tryFocus(focusBefore);
}
